<template>
  <v-card tile :color="color">
    <v-card-title>
      <v-icon large left>warning</v-icon>
      <span class="headline">{{label}}</span>
    </v-card-title>
    <v-divider />
    <v-card-text class="py-2">
      <span class="subheading">{{sublabel}}</span>
    </v-card-text>
    <v-divider />
    <v-card-text class="white">
      <v-list dense>
        <template v-for="(msg, index) in messages">
          <v-list-tile :key="index">
            <v-icon class="pr-2" color="error">clear</v-icon>
            <span class="body-1">{{ msg.Message }}</span>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
      sublabel: {
        type: String,
        default: '',
      },
      messages: {
        type: Array,
        default: () => [],
      },
      color: {
        type: String,
        default: 'amber lighten-1',
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .v-list {
    background-color: inherit;
  }
</style>